<div class="background-form" *ngIf="appointment">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 p-0">
                <div class="client-info p-5">
                    <img src="assets/images/logo.png" alt="Diagnostic Learning Services Logo" width="150"
                        class="img-fluid mb-5">
                        <h4 class="text-grey">Appointment Information</h4>
                        <hr>
                    <div class="detail">
                        <ul>
                            <li>
                                <label>Name</label>
                                <p>{{appointment.clientName}}</p>
                            </li>
                            <li>
                                <label>Determination</label>
                                <p>{{appointment.schoolType}}</p>
                            </li>
                            <li>
                                <label>Type of Test</label>
                                <p>{{appointment.assessmentType}}</p>
                            </li>
                            <li>
                                <label>Appointment Date/Time</label>
                                <p>{{appointment.appointmentDate}} (CST)</p>
                            </li>
                            <li>
                                <label>Location</label>
                                <p>{{appointment.Location}}</p>
                            </li>
                            <li>
                                <label>Diagnostician</label>
                                <p>{{appointment.diagnosticianName}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 px-0">
                <div class="form bg-white p-4">

                    <div class="d-flex align-items-center">
                      
                    <h4 class="text-green">Assessment Information</h4>
                    <a class="theme-button ml-md-auto mr-2" (click)="printPage()">Print Form</a>
                    <a class="theme-button grey" href="javascript:close_window();">Back</a>


                </div>
                    <form class="custom-form">

                        <div id="questionsBank" class="input-outer rounded bg-purple-light py-3 mt-4">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                      <label for="dateOfBirth">Date Of Birth *</label>

                                      <ng-container *ngIf="appointment.backgroundDetails.strDateOfBirth; else elseBlock">
                                        <!-- This block will be shown if 'condition' is true -->
                                        <!-- <p>The condition is true!</p> -->

                                        <input type="text" name="dateOfBirth" readonly [value]="appointment.backgroundDetails.strDateOfBirth" > 
                                      </ng-container>
                                      
                                      <!-- Define the 'else' template -->
                                      <ng-template #elseBlock>
                                        <!-- This block will be shown if 'condition' is false -->
                                        <!-- <p>The condition is false!</p> -->

                                        <input type="text" name="dateOfBirth" readonly [value]="appointment.backgroundDetails.dateOfBirth|date :'MM/dd/yyyy'" > 
                                      </ng-template>
                                      
                                        
                                      
                                       
                                      
                                    </div>
                                    <div class="col-md-6">
                                      <label for="currentSchool">Current School *</label>
                                      <input type="text" name="currentSchool" [(ngModel)]="appointment.backgroundDetails.currentSchool" readonly>
                                    </div>
                                  </div>
                            </div>
                            <div class="col-12">
                              <label for="question1">If your child speaks, is spoken to, or learns in a language other than English, please note what language(s) here:</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer1" readonly name="answer1" rows="1"></textarea>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="question27">Primary area of Concern/Reason for assessment *</label>
                                        <textarea [(ngModel)]="appointment.backgroundDetails.answer27" readonly name="answer27" rows="1"></textarea>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="question28">Additional area of Concern/Reason for assessment</label>
                                        <textarea [(ngModel)]="appointment.backgroundDetails.answer28" readonly name="answer28" rows="1"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                              <label for="question2">Please tell us specifically what has led to your concerns noted above. This can be your own observations as well as information from teachers/tutors. (Please be as specific as possible, this information will help us plan for your student's assessment) *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer2" readonly name="answer2" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question3">If your child has been diagnosed with any type of learning disability, ADHD, speech/language impairment, or physical disability, please indicate the type of diagnosis they have received.</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer3" readonly name="answer3" rows="1"></textarea>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-6">
                                  <label for="question4">Is your student receiving support through any of the following programs? *</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer4" readonly name="answer4" rows="1"></textarea>
                                </div>
                                <div class="col-md-6">
                                  <label for="question5">Please tell us the type of support and what accommodations they are currently receiving.</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer5" readonly name="answer5" rows="2"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-6">
                                  <label for="question6">Has your student ever repeated a grade? *</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer6" readonly name="answer6" rows="1"></textarea>
                                </div>
                                <div class="col-md-6">
                                  <label for="question7">If Yes, what grade?</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer7" readonly name="answer7" rows="1"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <label for="question8">Have there been any significant changes in the studentʼs life over the past 3 years? (separation, Divorce, birth of a sibling, death of a close relative, move, change of schools, etc) *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer8" readonly name="answer8" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-6">
                                  <label for="question9">Does your child have any specific medical conditions not mentioned above?  *</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer9" readonly name="answer9" rows="1"></textarea>
                                </div>
                                <div class="col-md-6">
                                  <label for="question10">If yes, please describe:</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer10" readonly name="answer10" rows="2"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-6">
                                  <label for="question11">Does your child regularly take any prescription medications? *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer11" readonly name="answer11" rows="3"></textarea>
                                </div>
                                <div class="col-md-6">
                                  <label for="question12">If yes, please describe:</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer12" readonly name="answer12" rows="2"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <label for="question13">Were there any complications during pregnancy or delivery? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer13" readonly name="answer13" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question14">Were all developmental milestones (crawling, walking, talking) met on time? If no, please describe: *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer14" readonly name="answer14" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question15">Is there a family history of any Learning Disabilities, ADHD, Depression, or Anxiety? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer15" readonly name="answer15" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question16">Please describe your childʼs grades for this school year. *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer16" readonly name="answer16" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question17">Please describe your childʼs grades for the 2-3 years prior to this school year. *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer17" readonly name="answer17" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question18">Please describe your child's attitude towards school. Do they love it, hate it, are somewhere in between, or just love it for the social/sports aspects? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer18" readonly name="answer18" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question19">What subjects or classes does your child enjoy the most? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer19" readonly name="answer19" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question20">What subjects or classes are most difficult for your child? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer20" readonly name="answer20" rows="3"></textarea>
                            </div>
                          </div>

                        <div id="checkboxBank" class="checkbox-outer rounded bg-theme-light py-3 mt-4">
                            <div class="col-12">
                                <h5>Please indicate your level of concern for each of the following behaviors: *</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white border rounded table-responsive mt-4">
                                    <table class="bg-white">
                                        <thead>
                                            <tr>
                                                <th>List of concerns</th>
                                                <th>No Concerns</th>
                                                <th>Mild Concerns</th>
                                                <th>Definite Concerns</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="1">
                                                <td>Concentrate when reading</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [attr.disabled]="true" name="concentrateWhenReading" 
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="concentrateWhenReading"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="concentrateWhenReading" [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label" for="concentrateWhenReading"
                                                            value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>


                                            <tr id="1">
                                                <td>Avoid distractions</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label" for="avoidDistractions"
                                                            value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">



                                                <td>Pay attention to a boring task</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Think before acting</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Wait for your turn</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Start something without being asked</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==1"
                                                            [attr.disabled]="true"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="startWithoutAsked"[attr.disabled]="true"
                                                        [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"[attr.disabled]="true"
                                                        [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Complete one task before starting a new one</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Get and stay organised</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Keep track of time</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="keepTrackOfTime"[attr.disabled]="true" class="custom-control-input" 
                                                        [checked]="appointment.backgroundDetails.keepTrackOfTime==1" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.keepTrackOfTime==2" [attr.disabled]="true"name="keepTrackOfTime"class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.keepTrackOfTime==3"[attr.disabled]="true" name="keepTrackOfTime" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Remember instructions</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberInstructions==1"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"[checked]="appointment.backgroundDetails.rememberInstructions==2"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberInstructions==3"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Remember what you have read</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberRead==1" [attr.disabled]="true"name="rememberRead"class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"[checked]="appointment.backgroundDetails.rememberRead==2"[attr.disabled]="true" name="rememberRead" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberRead==3"[attr.disabled]="true" name="rememberRead" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Control emotions under stress</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==1"[attr.disabled]="true" name="controlEmotions" class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==2"[attr.disabled]="true" name="controlEmotions" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==3"[attr.disabled]="true" name="controlEmotions"class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div id="questionsBank" class="input-outer rounded bg-purple-light py-3 mt-4">
                            <div class="col-12">
                              <label for="question21">What are some strengths of your child both in and outside of school? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer21" readonly name="answer21" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question22">Please describe things that your child enjoys doing outside of school? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer22" readonly name="answer22" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <label for="question23">How does your child relate to their peers? *</label>
                              <textarea [(ngModel)]="appointment.backgroundDetails.answer23" readonly name="answer23" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-md-4">
                                  <label for="question24">Would you like us to contact your student's teacher for additional information? *</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer24" readonly name="answer24" rows="3"></textarea>
                                </div>
                                <div class="col-md-4">
                                  <label for="question25">If yes, Teacher's name</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer25" readonly name="answer25" rows="2"></textarea>
                                </div>
                                <div class="col-md-4">
                                  <label for="question26">Teacher's email</label>
                                  <textarea [(ngModel)]="appointment.backgroundDetails.answer26" readonly name="answer26" rows="2"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                                <label for="backgroundFormComment">Referred By *</label>
                                <textarea [value]="appointment.backgroundDetails.backgroundFormComment" readonly rows="3"></textarea>
                            </div>
                            <div class="col-12" *ngIf="appointment.backgroundDetails.guardians && appointment.backgroundDetails.guardians.length > 0">
                                <hr>
                                <div class="legal-guardian-section bg-purple-light p-4 mt-3 rounded">
                                    <h5 class="mb-3">Legal Educational Decision-Making Rights</h5>
                                    
                                    <div *ngFor="let guardian of appointment.backgroundDetails.guardians" class="guardian-entry mb-3 p-3 bg-white border rounded">
                                        <div class="row align-items-center">
                                            <div class="col-md-4">
                                                <label>Name</label>
                                                <input type="text" readonly [value]="guardian.name" class="form-control bg-light">
                                            </div>
                                            <div class="col-md-4">
                                                <label>Relationship to student</label>
                                                <input type="text" readonly [value]="guardian.relationship" class="form-control bg-light">
                                            </div>
                                            <div class="col-md-4">
                                                <label>Aware of evaluation?</label>
                                                <input type="text" readonly [value]="guardian.isAware ? 'Yes' : 'No'" 
                                                       class="form-control bg-light font-weight-bold" 
                                                       [ngClass]="{'text-danger': !guardian.isAware}">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="consent-block mt-4" *ngIf="appointment.backgroundDetails.consentConfirmation">
                                        <div class="custom-control custom-checkbox mt-3">
                                            <input type="checkbox" readonly checked disabled class="custom-control-input" id="consentCb">
                                            <label class="custom-control-label font-weight-bold" for="consentCb" style="opacity: 1;">Consent Confirmed</label>
                                        </div>

                                        <div class="signature-block mt-4" *ngIf="appointment.backgroundDetails.signatureData">
                                            <label>Signature</label>
                                            <div class="signature-pad-container" style="border: 1px solid #ccc; max-width: 500px; height: 200px; background-color: #fff; overflow: hidden;">
                                                <img [src]="appointment.backgroundDetails.signatureData" style="max-width: 100%; max-height: 100%;">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Name of Individual submitting this information</label>
                                        <input type="text" readonly [value]="appointment.backgroundDetails.submitterName || appointment.backgroundDetails.formFilledBy" class="form-control bg-light">
                                    </div>
                                    <div class="col-md-6">
                                        <label>Submission Date</label>
                                        <input type="text" readonly [value]="appointment.backgroundDetails.submissionDate || '-'" class="form-control bg-light">
                                    </div>
                                </div>
                            </div>
                          </div>
                        
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>